// extracted by mini-css-extract-plugin
export default {"Box":"route-title-module__Box--JGk6t","Octicon":"route-title-module__Octicon--NtaO3","Heading":"route-title-module__Heading--UT4Qm"};